import { Button } from '@mui/material';

import { FC } from 'react';
import { IconButton, Tooltip } from '@mui/material';

interface DataGridToolProps {
  onClick: () => void;
  tooltip?: string;
  label?: string;
  icon?: React.ReactNode;
  isIconButton?: boolean;
  variant?: 'outlined' | 'contained';
  disabled?: boolean;
}

export const DataGridTool: FC<DataGridToolProps> = ({
  onClick,
  tooltip,
  label,
  icon,
  isIconButton = false,
  variant = 'outlined',
  disabled = false,
}) => {
  return (
    <Tooltip title={disabled ? '' : tooltip}>
      {isIconButton ? (
        <IconButton
          onClick={onClick}
          sx={{ '&:hover': { color: disabled ? 'secondary.light' : 'primary.light' } }}
          disabled={disabled}
        >
          {icon}
        </IconButton>
      ) : (
        <Button
          onClick={onClick}
          variant={variant}
          color="secondary"
          sx={{
            backgroundColor: 'transparent',
            height: '40px',
            '&:hover': {
              border: `1px solid`,
              borderColor: disabled ? 'divider' : 'primary.light',
              color: disabled ? 'divider' : 'primary.light',
            },
          }}
        >
          {icon}
          {label}
        </Button>
      )}
    </Tooltip>
  );
};

export default DataGridTool;
